import { LANGUAGE } from "@/common/utils/constants.js";

export const HOME_PAGE = {
	[LANGUAGE.en.short]: {
		heroTitle: "Welcome to Akkodis Digital Reference Catalogue",
		shareYourStoryLink: "Share your success story",
		goToStoriesSectionLink: "Browse stories",
		testimonial: "The DRC serves as a strategic enabler of our growth, providing sales account leads with resources to deliver compelling client success stories and respond accurately to RFPs.",
		testimonialsRole: "Akkodis President",
		industriesSectionTitle: "Key industries",
		storiesByAkkodisSectionTitle: "Stories by Akkodis location",
		useFilters: "Use filters",
		all: 'All',
		diveIn: 'Dive in',
		globalActivityDashboard: 'Global Activity Dashboard',
		globalActivityDashboardHint: 'Highlights delivery locations of published client projects. Light yellow for moderate activity, bright yellow for high. Greyed-out regions indicate no activity.',
		stayInformed: 'Stay informed on submission trends. Subscribe to receive timely updates.',
		subscribe: 'Subscribe',
		subscribed: 'Subscribed',
		mostActive: 'Most active',
		mediumActive: 'Medium active',
		last30Days: 'Last 30 days',
		last90Days: 'Last 90 days',
		topContributors: 'Top Contributors',
		topContributorsHint: 'Shows users with the highest number of published client stories. Updated automatically based on submitted and approved projects.',
		meetMostEngaged:'Meet our most engaged members',
		subscribers: `Jo Debecker & {num} others are subscribed`,
		featuredStories: 'Featured stories',
		exploreAllProjects: 'Explore all projects',
		president: 'Akkodis President',
		readMore: 'Read more'
	},
	[LANGUAGE.it.short]: {
		heroTitle: "Benvenuti nel catalogo di riferimento digitale Akkodis",
		shareYourStoryLink: "Condividi la tua storia di successo",
		goToStoriesSectionLink: "Sfoglia storie",
		testimonial: "La DRC svolge il ruolo di facilitatore strategico della nostra crescita, fornendo ai responsabili degli account di vendita le risorse necessarie per raccontare storie di successo convincenti dei clienti e rispondere in modo accurato alle richieste di proposta.",
		testimonialsRole: "Presidente di Akkodis",
		industriesSectionTitle: "Industrie chiave",
		storiesByAkkodisSectionTitle: "Storie della posizione di Akkodis",
		useFilters: "Usa i filtri",
		all: 'Tutto',
		diveIn: 'Tuffati',
		globalActivityDashboard: 'Dashboard attività globale',
		globalActivityDashboardHint: 'Evidenzia i luoghi di consegna dei progetti pubblicati dai clienti. Giallo chiaro per attività moderata, giallo brillante per attività elevata. Le aree in grigio indicano assenza di attività.',
		stayInformed: 'Resta informato sulle tendenze di presentazione. Iscriviti per ricevere aggiornamenti tempestivi.',
		subscribe: 'Iscriviti',
		subscribed: 'Iscritto',
		mostActive: 'Più attivo',
		mediumActive: 'Medio attivo',
		last30Days: 'Ultimi 30 giorni',
		last90Days: 'Ultimi 90 giorni',
		topContributors: 'Top Contributor',
		topContributorsHint: 'Mostra gli utenti con il maggior numero di storie cliente pubblicate. Aggiornato automaticamente in base ai progetti inviati e approvati.',
		meetMostEngaged:'Incontra i nostri membri più impegnati',
		subscribers: `Jo Debecker e altri {num} sono iscritti`,
		featuredStories: 'Storie in evidenza',
		exploreAllProjects: 'Esplora tutti i progetti',
		president: 'Akkodis Presidente',
		readMore: 'Mehr lesen'
	},
	[LANGUAGE.de.short]: {
		heroTitle: "Willkommen im Akkodis Digital Reference Catalog",
		shareYourStoryLink: "Teilen Sie Ihre Erfolgsgeschichte mit",
		goToStoriesSectionLink: "Geschichten durchsuchen",
		testimonial: "Das DRC dient als strategischer Motor unseres Wachstums und stellt den Vertriebsleitern Ressourcen zur Verfügung, um überzeugende Erfolgsgeschichten für Kunden zu liefern und präzise auf RFPs zu reagieren.",
		testimonialsRole: "Akkodis -Präsident",
		industriesSectionTitle: "Schlüsselindustrien",
		storiesByAkkodisSectionTitle: "Geschichten von Akkodis Standort",
		useFilters: "Verwenden Sie Filter",
		all: 'Alle',
		diveIn: 'Eintauchen',
		globalActivityDashboard: 'Globales Aktivitäts-Dashboard',
		globalActivityDashboardHint: 'Markiert die Lieferorte veröffentlichter Kundenprojekte. Hellgelb steht für mittlere Aktivität, leuchtendes Gelb für hohe. Ausgegraute Bereiche zeigen keine Aktivität an.',
		stayInformed: 'Bleiben Sie über Einreichungstrends informiert. Abonnieren Sie, um rechtzeitig Updates zu erhalten.',
		subscribe: 'Abonnieren',
		subscribed: 'Abonniert',
		mostActive: 'Am aktivsten',
		mediumActive: 'Mittelaktiv',
		last30Days: 'Letzte 30 Tage',
		last90Days: 'Letzte 90 Tage',
		topContributors: 'Top-Beiträger',
		topContributorsHint: 'Zeigt die Benutzer mit der höchsten Anzahl veröffentlichter Kundengeschichten an. Automatische Aktualisierung basierend auf eingereichten und genehmigten Projekten.',
		meetMostEngaged:'Treffe unsere engagiertesten Mitglieder',
		subscribers: `Jo Debecker und {num} andere sind abonniert`,
		featuredStories: 'Ausgewählte Geschichten',
		exploreAllProjects: 'Alle Projekte erkunden',
		president: 'Akkodis Präsident',
		readMore: 'En savoir plus'
	},
	[LANGUAGE.fr.short]: {
		heroTitle: "Bienvenue dans le catalogue de référence numérique Akkodis",
		shareYourStoryLink: "Partagez votre réussite",
		goToStoriesSectionLink: "Parcourir les histoires",
		testimonial: "Le DRC sert de catalyseur stratégique à notre croissance, en fournissant aux prospects des comptes de vente des ressources pour fournir des histoires de réussite client convaincantes et répondre avec précision aux appels d'offres.",
		testimonialsRole: "Président d'Akkodis",
		industriesSectionTitle: "Industries clés",
		storiesByAkkodisSectionTitle: "Histoires de l'emplacement d'Akkodis",
		useFilters: "Utiliser des filtres",
		all: 'Tout',
		diveIn: 'Découvrir',
		globalActivityDashboard: 'Tableau de bord des activités mondiales',
		globalActivityDashboardHint: 'Indique les lieux de livraison des projets clients publiés. Jaune clair pour une activité modérée, jaune vif pour une activité élevée. Les zones grisées indiquent l\'absence d\'activité.',
		stayInformed: 'Restez informé des tendances de soumission. Abonnez-vous pour recevoir des mises à jour en temps opportun.',
		subscribe: 'Souscrire',
		subscribed: 'Abonné',
		mostActive: 'Le plus actif',
		mediumActive: 'Moyennement actif',
		last30Days: '30 derniers jours',
		last90Days: '90 derniers jours',
		topContributors: 'Meilleurs contributeurs',
		topContributorsHint: 'Affiche les utilisateurs ayant publié le plus grand nombre de témoignages clients. Mise à jour automatique en fonction des projets soumis et approuvés.',
		meetMostEngaged:'Rencontrez nos membres les plus engagés',
		subscribers: `Jo Debecker et {num} autres sont abonnés`,
		featuredStories: 'Histoires en vedette',
		exploreAllProjects: 'Explorer tous les projets',
		president: 'Akkodis Président',
		readMore: 'Per saperne di più'
	},
	[LANGUAGE.ja.short]: {
		heroTitle: "Akkodisデジタルリファレンスカタログへようこそ",
		shareYourStoryLink: "あなたのサクセスストーリーを共有してください",
		goToStoriesSectionLink: "物語を閲覧します",
		testimonial: "DRC は、当社の成長を戦略的に促進する役割を担い、セールス アカウント リードにリソースを提供して、説得力のあるクライアント成功事例を提供し、RFP に正確に応答します。",
		testimonialsRole: "Akkodis社長",
		industriesSectionTitle: "主要産業",
		storiesByAkkodisSectionTitle: "Akkodisの場所によるストーリー",
		useFilters: "フィルターを使用する",
		all: '全て',
		diveIn: 'ダイブイン',
		globalActivityDashboard: 'グローバルアクティビティダッシュボード',
		globalActivityDashboardHint: '公開済みのクライアントプロジェクトの納品場所をハイライト表示します。アクティビティが中程度の場合は明るい黄色、アクティビティが高い場合は明るい黄色です。グレーアウトされている地域はアクティビティがないことを示します。',
		stayInformed: '提出トレンドについて最新情報を入手します。タイムリーな更新を受け取るために購読してください。',
		subscribe: '購読する',
		subscribed: '購読済み',
		mostActive: '最もアクティブ',
		mediumActive: '中程度アクティブ',
		last30Days: '過去30日間',
		last90Days: '過去90日間',
		topContributors: 'トップ貢献者',
		topContributorsHint: '公開済みのクライアントストーリー数が最も多いユーザーを表示します。提出済みおよび承認済みのプロジェクトに基づいて自動的に更新されます。',
		meetMostEngaged:'最も熱心なメンバーに会う',
		subscribers: `Jo Debecker およびその他{num}人が購読しています`,
		featuredStories: '特集ストーリー',
		exploreAllProjects: 'すべてのプロジェクトを探索する',
		president: 'Akkodis 社長',
		readMore: '続きを読む'
	},
	[LANGUAGE.es.short]: {
		heroTitle: "Bienvenido al Catálogo de Referencia Digital de Akkodis",
		shareYourStoryLink: "Comparte tu historia de éxito",
		goToStoriesSectionLink: "Explorar historias",
		testimonial: "El DRC sirve como un facilitador estratégico de nuestro crecimiento, proporcionando a los líderes de cuentas de ventas recursos para entregar historias de éxito convincentes y responder con precisión a las RFP.",
		testimonialsRole: "Presidente de Akkodis",
		industriesSectionTitle: "Industrias clave",
		storiesByAkkodisSectionTitle: "Historias por ubicación de Akkodis",
		useFilters: "Usar filtros",
		all: 'Todo',
		diveIn: 'Sumérgete',
		globalActivityDashboard: 'Panel de actividad global',
		globalActivityDashboardHint: 'Destaca las ubicaciones de entrega de proyectos publicados por clientes. Amarillo claro para actividad moderada, amarillo brillante para alta. Las regiones en gris indican sin actividad.',
		stayInformed: 'Mantente informado sobre las tendencias de envío. Suscríbete para recibir actualizaciones oportunas.',
		subscribe: 'Suscribirse',
		subscribed: 'Suscrito',
		mostActive: 'Más activo',
		mediumActive: 'Medio activo',
		last30Days: 'Últimos 30 días',
		last90Days: 'Últimos 90 días',
		topContributors: 'Principales contribuyentes',
		topContributorsHint: 'Muestra usuarios con el mayor número de historias de clientes publicadas. Actualizado automáticamente según los proyectos enviados y aprobados.',
		meetMostEngaged:'Conoce a nuestros miembros más comprometidos',
		subscribers: 'Jo Debecker y otros 1k están suscritos',
		featuredStories: 'Historias destacadas',
		exploreAllProjects: 'Explorar todos los proyectos',
		president: 'Presidente de Akkodis',
		readMore: 'Leer más'
	}
}
